import React, {useRef} from 'react'
import './home.css';
import TechnologiesList from '../../components/TechnologiesList';
import CardProject from '../../components/CardProjects';
import VideoScroll from '../../components/VideoScroll';

export default function Home()
{
    
const boundRef = useRef(null);

    return (
        <div className="About-me">
        <div className="banner-about-me">
            <div className="descripcion-home column-triple">
                <div className="descripcion-home-title">Hi! I'm Vivian Gómez</div>
                <div className="descripcion-home-text">
                    <p>I am a Systems and Computing Engineer  with passion in Visual Computing and Design. I studied at Universidad de los Andes in Bogotá, Colombia. 
                       <br/> 
                       <br/> 
                        I’m interested in web development, specially front-end, design UI/UX, videogames, VR, MR and AR development. 
                    </p>
                </div>
            </div>
            <div className="img-banner-about column-double" alt="Hi, I am Vivian Gómez">
            </div>
        </div>
        <div className="row" ref={boundRef}>
            <VideoScroll boundRefP={boundRef}/> 
            <div className="wrapper-technologies">
                <TechnologiesList/>
            </div>
        </div>
        <div className="row">
            <div className="column">
                <CardProject id="dev" title="Dev projects" image="img-dev-projects" styleBtn="btnDev" pathP="/dev-projects" />
            </div>
            <div className="column">
                <CardProject id="design" title="Design portfolio" image="img-design-projects" styleBtn="btnDesign" pathP="/design-portfolio"/>
            </div>
        </div>
    </div>
    )
}